import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { InView } from 'react-intersection-observer'
import { Table, TableSearch } from 'shared/ui/TableNew'
import { Button, EmptyState, SpinnerLoader, Typography } from 'shared/ui'
import { useInboxLayerContext } from 'pages/settings/pages/inboxes/context/inboxLayerContext'

import styles from './styles.module.scss'

export const MembersTabContent = observer(() => {
  const { membersStore } = useInboxLayerContext()
  const {
    getMembersTableColumns,
    membersTableRows,
    noResultsFound,
    loading,
    isHasMore,
    ownerMember,
    tableStore,
    openDeleteMemberModal,
    loadMore,
    addNewMembersClick,
  } = membersStore
  const { selectedIds } = tableStore

  const columns = useMemo(() => getMembersTableColumns, [membersStore])
  const isOwner = ownerMember?.id ? selectedIds.includes(ownerMember.id) : false

  if (loading) {
    return <SpinnerLoader ariaLabel={'MembersTabContent'} />
  }

  const tableContent = noResultsFound ? (
    <EmptyState text='No results found' />
  ) : (
    <div className={styles.tableContainer}>
      <Table
        ariaLabel='members-table'
        store={tableStore}
        columns={columns}
        rows={membersTableRows}
        withCheckbox={true}
        headerLeftContentProps={{
          actionsContent: (
            <Button
              text={selectedIds.length > 1 ? 'Remove members' : 'Remove member'}
              icon='delete'
              size='small'
              contained='tertiary'
              disabled={isOwner}
              onClick={() => openDeleteMemberModal(selectedIds as number[])}
              tooltipProps={{
                visibility: isOwner ? 'visible' : 'hidden',
                placement: 'top',
                label: 'You can’t remove inbox owner',
              }}
            />
          ),
        }}
        hidePagination
        bottomTableContent={
          <tr>
            <td className={styles.footer} colSpan={4}>
              <InView onChange={(inView) => inView && loadMore()}>
                {({ ref }) => (
                  <div className={styles.footerContent} ref={ref}>
                    {isHasMore && <SpinnerLoader ariaLabel={'MembersTabContent'} size={16} />}
                  </div>
                )}
              </InView>
            </td>
          </tr>
        }
      />
    </div>
  )

  return (
    <div className={styles.container}>
      <div className={styles.actionsContainer}>
        <Typography ariaLabel='members-title' variant='heading-sm'>
          Members
        </Typography>
        <Button text='Add members' icon='add' color='primary' onClick={addNewMembersClick}>
          Add Member
        </Button>
      </div>
      <TableSearch
        className={styles.search}
        value={membersStore.search}
        onChange={membersStore.setSearch}
      />
      {tableContent}
    </div>
  )
})
